<template>
  <div v-if="exercises.length" class="items">
    <ChapterBlockExerciseItem
      v-for="(exercise, index) in exercises"
      :id="exercise.id"
      :key="exercise.id"
      :library-book-id="libraryBookId"
      :index="index"
      :length="exercises.length"
      :path="exercise.path"
      :score="exercise.score"
      :nb-items-completed="nbItemsCompleted"
      :completed="exercise.completed"
      :on-going="exercise.onGoing"
      :previous-completed="exercise.previousCompleted"
      :next-completed="exercise.nextCompleted"
      :text="exercise.text"
      :available-by-order="true"
      :is-parent-child-page="isParentChildPage"
      :locked-content="exercise.lockedContent"
      :focused="index === focusedIndex"
    />
  </div>
</template>
<script lang="ts" setup>
interface ViewProps {
  category: CategorySchema;
}
const props = defineProps({
  category: null
});

const { currentContent } = inject(INJECT_CATEGORY_PAGE);

const libraryBookId = computed(() => currentContent.value.id);

const { isParentChildPage, nbItemsCompleted, exercises, focusedIndex } =
  useCategoryBlockExercises(props.category);
</script>
<style lang="scss" scoped>
.items {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 1.4rem 0;
}
</style>
